import { AlertTriangle, Shield, Lock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

interface AccessDeniedProps {
  requiredRole?: string;
  moduleName?: string;
}

export function AccessDenied({ requiredRole = "admin", moduleName = "esta funcionalidade" }: AccessDeniedProps) {
  const { profile } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Card className="w-full max-w-md border-0 shadow-lg">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <Shield className="h-8 w-8 text-red-600" />
          </div>
          <CardTitle className="text-xl font-semibold text-gray-900">
            Acesso Negado
          </CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div className="space-y-2">
            <p className="text-gray-600">
              Você não tem permissão para acessar <strong>{moduleName}</strong>.
            </p>
            <p className="text-sm text-gray-500">
              Esta funcionalidade requer permissão de <strong>{requiredRole}</strong>.
            </p>
          </div>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="h-4 w-4 text-blue-600" />
              <span className="text-sm font-medium text-blue-800">Seu perfil atual</span>
            </div>
            <p className="text-sm text-blue-700">
              Role: <strong>{profile?.role || 'Não definido'}</strong>
            </p>
            <p className="text-sm text-blue-700">
              Nome: <strong>{profile?.nome || 'Não definido'}</strong>
            </p>
          </div>

          <div className="pt-4">
            <Button 
              onClick={() => window.history.back()} 
              className="w-full bg-blue-600 hover:bg-blue-700"
            >
              Voltar
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
} 